function commaSeparator(number) {
  const numberParts = number.toString().split('.');
  numberParts[0] = numberParts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return numberParts.join('.');
}
export default commaSeparator;